import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MobilePaymentRoutingModule } from './mobile-payment-routing.module';
import { MobilePaymentComponent } from './components/mobile-payment/mobile-payment.component';


@NgModule({
  declarations: [
    MobilePaymentComponent
  ],
  imports: [
    CommonModule,
    MobilePaymentRoutingModule
  ]
})
export class MobilePaymentModule { }
